import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";

import {
  FeildError,
  FeildWraper,
  FileUploadProgressBar,
  FormArea,
  FormHeading1,
  FormLabel,
  FormLineBreak,
  SelectSearch,
} from "../../../component/form/form-layout";
import LeftSidePopupLayout from "../../../component/popup/modal-layout";

import { GlobalContext } from "../../../context/Context";
import XCloseIcon from "../../../component/icons/x-close";
import InnerLoader from "../../../component/ui/loader/inner-loader";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import { Delete } from "lucide-react";
import Swal from "sweetalert2";

const RefundForm = ({
  onSubmit = () => { },
  onClose = () => { },
  onError = () => { },
  refundDataId = {},
}) => {
  let { state } = useContext(GlobalContext);

  let {
    agentList,
    cbOrRefundOptions,
    cbOutcomeOptions,
    qaStatusOptions,
    retentionOutcomeOptions,
    retentionAttemptOptions,
    responsibleOptions,
    sourceOptions,
    workStatusOptions,
    brandoptions,
    merchantoptions,
    processoroptions,
    productoptions,
    businessUnits
  } = state?.DropdownData || {};

  const editid = refundDataId?.id;
  const [refundData, setRefundData] = useState([]);

  const [buttonLoader, setButtonLoader] = useState(false);

  const [uploadFileId, setUploadFileId] = useState("");

  // console.log("uploadFiles", uploadFiles)

  const [editLoading, setEditLoading] = useState(false);

  const apiCall = useApiCall();

  const getEditFeilds = async () => {
    if (!editid) return;

    setEditLoading(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `refund-trackers/edit-refund/${editid}`,
      });

      setRefundData(res?.data || []);
    } catch (error) {
      console.warn("Error fetching refund data:", error);
    } finally {
      setEditLoading(false);
    }

  };

  useEffect(() => {
    if (editid) {
      getEditFeilds();
    }
  }, []);

  useEffect(() => {
    if (!refundData?.id) return;

    const values = { ...formik.values };

    const fields = [
      "ref_no",
      "order_id",
      "client_name",
      "email",
      "brand_website",
      "merchant_name",
      "processor",
      "product_service",
      "order_date",
      "amount_paid",
      "work_status",
      "project_percent_done",
      "cb_or_refund",
      "request_date",
      "process_date",
      "refund_amount",
      "dispute_amount",
      "source",
      "front_sale",
      "account_manager",
      "processor_reason_code",
      "qa_status",
      "identified_by_qa",
      "responsible",
      "responsible_person",
      "qa_executive",
      "qa_analysis",
      "disagreement_with_qa",
      "qa_decision_changed",
      "qa_of_qa",
      "first_call_upsell_attempt",
      "retention_attempted",
      "retention_outcome",
      "cb_outcome",
      "recovery_rate_percent",
      "case_study",
      "cs_attachment_id"
    ];

    const numberFields = [
      "brand_website",
      "merchant_name",
      "processor",
      "product_service",
      "work_status",
      "cb_or_refund",
      "source",
      "qa_status",
      "account_manager",
      "front_sale",
      "qa_executive",
      "retention_outcome",
      "cb_outcome",
      "responsible",
      "responsible_person",
    ];

    fields.forEach((field) => {
      let value = refundData?.[field] ?? "";

      if (numberFields.includes(field)) {
        value = value !== null && value !== "" ? Number(value) : "";
      }

      values[field] = value;
    });

    // if (refundData.cs_attachment_id) {
    //   setUploadFiles({
    //     id: refundData.cs_attachment_id,
    //     name: refundData.file_name,
    //     size: refundData.cs_attachment.size,
    //     url: refundData.cs_attachment.file_url,
    //   });
    // }

    values.business_unit = refundData?.agent_heads?.business_unit ?? "";
    values.reporting_authority =
      refundData?.agent_heads?.reporting_authority ?? "";
    values.team_lead_1 = refundData?.agent_heads?.team_lead_1 ?? "";
    values.team_lead_2 = refundData?.agent_heads?.team_lead_2 ?? "";

    formik.setValues(values);
  }, [refundData]);

  const YesNo = [
    {
      key: "Yes",
      value: "Yes",
    },
    {
      key: "No",
      value: "No",
    },
  ];

  const agentOptions = agentList?.map((each) => ({
    value: each.userid,
    label: each.name,
  }));

  const currentUserId = state?.user?.userid;

  const qaExecutiveList = agentList?.filter(
    (each) => each.usertype === 6
  );

  const currentQaExecutive = qaExecutiveList?.find(
    (each) => each.userid === currentUserId
  );

  const qaExecutiveOptions = currentQaExecutive
    ? [
      {
        value: currentQaExecutive.name,
        label: currentQaExecutive.name,
      },
    ]
    : qaExecutiveList?.map((each) => ({
      value: each.name,
      label: each.name,
    }));

  useEffect(() => {
    if (currentQaExecutive) {
      formik.setFieldValue("qa_executive", currentQaExecutive.name);
    }
  }, [currentQaExecutive]);

  const yesNoOptions = YesNo?.map((each) => ({
    value: each.key,
    label: each.value,
  }));



  const validationSchema = yup.object({
    ref_no: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    order_id: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    client_name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    // work_status: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    email: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    brand_website: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    merchant_name: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    processor: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    product_service: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    order_date: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    amount_paid: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    // project_percent_done: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    cb_or_refund: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    request_date: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    process_date: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    refund_amount: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    // dispute_amount: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // source: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // front_sale: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // account_manager: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // processor_reason_code: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // qa_status: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // identified_by_qa: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    responsible: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    // business_unit: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // reporting_authority: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // team_lead_1: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // team_lead_2: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // responsible_person: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // qa_executive: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // qa_analysis: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // disagreement_with_qa: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // qa_decision_changed: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // qa_of_qa: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // first_call_upsell_attempt: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // retention_attempted: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // retention_outcome: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // cb_outcome: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // net_loss: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // recovery_rate_percent: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
    // case_study: yup
    //   .string("This Field is Required")
    //   .required("This Field is Required"),
  });

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ];

  // const uploadAttachments = async () => {
  //   if (uploadFiles?.id) return uploadFiles.id;

  //   if (!uploadFiles) return null;



  //   const formData = new FormData();
  //   formData.append("files[]", uploadFiles);
  //   const res = await apiCall({
  //     method: "post",
  //     url: "attachments/upload",
  //     data: formData,
  //     headers: { "Content-Type": "multipart/form-data" },
  //   });

  //   return res?.data[0]?.id || [];
  // };

  const formik = useFormik({
    initialValues: (localStorage?.getItem("refundFormPrefilled") && !refundData?.id) ? JSON.parse(localStorage?.getItem("refundFormPrefilled")) : {
      ref_no: "",
      order_id: "",
      client_name: "",
      email: "",
      brand_website: "",
      merchant_name: "",
      processor: "",
      product_service: "",
      order_date: "",
      amount_paid: "",
      work_status: "",
      project_percent_done: "",
      cb_or_refund: "",
      request_date: "",
      process_date: "",
      refund_amount: "",
      dispute_amount: "",
      source: "",
      front_sale: "",
      account_manager: "",
      processor_reason_code: "",
      qa_status: "",
      identified_by_qa: "",
      responsible: "",
      business_unit: "",
      reporting_authority: "",
      team_lead_1: "",
      team_lead_2: "",
      responsible_person: "",
      qa_executive: "",
      qa_analysis: "",
      disagreement_with_qa: "",
      qa_decision_changed: "",
      qa_of_qa: "",
      first_call_upsell_attempt: "",
      retention_attempted: "",
      retention_outcome: "",
      cb_outcome: "",
      cs_attachment_id: "",
      net_loss: "",
      recovery_rate_percent: "",
      case_study: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log("uploadfiles", uploadFiles.type)

      // if (uploadFiles && !allowedTypes.includes(uploadFiles.type) && !uploadFiles.id) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Invalid File",
      //     text: "Only PDF, DOC, and DOCX files are allowed",
      //   });
      //   return
      // }
      setButtonLoader(true);

      localStorage.setItem("refundFormPrefilled", JSON.stringify(values))

      try {

        // const attachmentIds = await uploadAttachments();
        // values.cs_attachment_id = attachmentIds;

        let extraField = {};

        if (values.responsible != "2") {
          extraField = {
            team_lead_1: values?.team_lead_1,
            team_lead_2: values?.team_lead_2,
            responsible_person: values?.responsible_person,
            reporting_authority: values?.reporting_authority,
          };
        }

        if (values.cb_or_refund == 2 || values.cb_or_refund == 3 || values.cb_or_refund == 4) {
          extraField = {
            ...extraField,
            cb_outcome: values?.cb_outcome,
          };
        }

        let data = {
          ...extraField,
          ref_no: values?.ref_no,
          order_id: values?.order_id,
          client_name: values?.client_name,
          email: values?.email,
          brand_website: values?.brand_website,
          merchant_name: values?.merchant_name,
          processor: values?.processor,
          product_service: values?.product_service,
          order_date: values?.order_date,
          amount_paid: Number(values?.amount_paid),
          work_status: values?.work_status,
          project_percent_done: values?.project_percent_done,
          cb_or_refund: values?.cb_or_refund,
          request_date: values?.request_date,
          process_date: values?.process_date,
          refund_amount: Number(values?.refund_amount),
          dispute_amount: 0,
          source: values?.source,
          front_sale: values?.front_sale,
          account_manager: values?.account_manager,
          processor_reason_code: values?.processor_reason_code,
          qa_status: values?.qa_status,
          identified_by_qa: values?.identified_by_qa,
          responsible: values?.responsible,
          business_unit: values?.business_unit,
          qa_executive: values?.qa_executive,
          qa_analysis: values?.qa_analysis,
          disagreement_with_qa: values?.disagreement_with_qa,
          qa_decision_changed: values?.qa_decision_changed,
          qa_of_qa: values?.qa_of_qa,
          first_call_upsell_attempt: values?.first_call_upsell_attempt,
          retention_attempted: values?.retention_attempted,
          retention_outcome: values?.retention_outcome,
          // cb_outcome: values?.cb_outcome,
          recovery_rate_percent: Number(values?.recovery_rate_percent),
          case_study: values?.case_study,
          cs_attachment_id: uploadFileId
        };

        // console.log(data)




        const apiRes = await apiCall({
          method: "post",
          url: refundData?.id
            ? `refund-trackers/update-refund/${refundData.id}`
            : `refund-trackers/add`,
          data: data,
        });
        setButtonLoader(false);

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        setButtonLoader(false);
        onError(
          error?.response.data?.respMsg ||
          error?.response.data?.responseMessage ||
          error?.response.data?.message ||
          "Some Thing Went Wrong"
        );
      }
    },
  });


  // const isSalesResponsible = String(formik.values.responsible) === "1";

  // console.log(formik.values.responsible);
  // console.log(isSalesResponsible)

  // useEffect(() => {
  //   if (!isSalesResponsible) {
  //     formik.setFieldValue("team_lead_1", "");
  //     formik.setFieldValue("team_lead_2", "");
  //     formik.setFieldValue("responsible_person", "");
  //   }
  // }, [isSalesResponsible]);


  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0 rounded-[15px] w-[97%] ml-[auto] mr-[0] mt-[6px] h-[99vh] overflow-hidden`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{refundData?.id ? "Update" : "Add"} Refund</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        {editLoading ? (

          <InnerLoader />

        ) : (

          <>
            <div className={`${Style.addMeModal_body}`}>
              <div className={`${Style.dcmb__card}`}>
                <div className={`${Style.dcmb__cardBody}`}>
                  <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                    <FormArea>
                      <FormHeading1>Order Details</FormHeading1>
                      {/* 1. Ref No */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Ref No</FormLabel>
                        <input
                          type="text"
                          name="ref_no"
                          value={formik.values.ref_no}
                          onChange={formik.handleChange}
                          placeholder="Ref No"
                        />
                        {formik.touched.ref_no && formik.errors.ref_no && (
                          <FeildError>{formik.errors.ref_no}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 2. Order ID */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Order ID</FormLabel>
                        <input
                          type="text"
                          name="order_id"
                          value={formik.values.order_id}
                          onChange={formik.handleChange}
                          placeholder="Order ID"
                        />
                        {formik.touched.order_id && formik.errors.order_id && (
                          <FeildError>{formik.errors.order_id}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 3. Client Name */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Client Name</FormLabel>
                        <input
                          type="text"
                          name="client_name"
                          value={formik.values.client_name}
                          onChange={formik.handleChange}
                          placeholder="Client Name"
                        />
                        {formik.touched.client_name &&
                          formik.errors.client_name && (
                            <FeildError>{formik.errors.client_name}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 4. Email */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Email</FormLabel>
                        <input
                          type="text"
                          name="email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          placeholder="Email"
                        />
                        {formik.touched.email && formik.errors.email && (
                          <FeildError>{formik.errors.email}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 5. Brand */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Brand</FormLabel>
                        <SelectSearch
                          name="brand_website"
                          options={brandoptions}
                          onChange={(val) => { formik.setFieldValue("brand_website", val); }}
                          value={formik.values.brand_website}
                          placeholder="Search or select Brands..."
                          menuPosition="fixed"
                        />
                        {formik.touched.brand_website &&
                          formik.errors.brand_website && (
                            <FeildError>{formik.errors.brand_website}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 6. Merchant Name */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Merchant Name</FormLabel>
                        <SelectSearch
                          name="merchant_name"
                          options={merchantoptions}
                          onChange={(val) => { formik.setFieldValue("merchant_name", val); }}
                          value={formik.values.merchant_name}
                          placeholder="Search or select Merchant..."
                        />
                        {formik.touched.merchant_name &&
                          formik.errors.merchant_name && (
                            <FeildError>{formik.errors.merchant_name}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 7. Processor */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Processor</FormLabel>
                        <SelectSearch
                          name="processor"
                          options={processoroptions}
                          onChange={(val) => { formik.setFieldValue("processor", val); }}
                          value={formik.values.processor}
                          placeholder="Search or select Processor..."
                        />
                        {formik.touched.processor && formik.errors.processor && (
                          <FeildError>{formik.errors.processor}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 8. Product */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Product</FormLabel>
                        <SelectSearch
                          name="product_service"
                          options={productoptions}
                          onChange={(val) => { formik.setFieldValue("product_service", val); }}
                          value={formik.values.product_service}
                          placeholder="Search or select Product..."
                        />
                        {formik.touched.product_service &&
                          formik.errors.product_service && (
                            <FeildError>{formik.errors.product_service}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 9. Order Date */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Order Date</FormLabel>
                        <input
                          type="date"
                          name="order_date"
                          max={new Date().toISOString().split("T")[0]}
                          value={formik.values.order_date}
                          onChange={formik.handleChange}
                          placeholder="Order Date"
                        />
                        {formik.touched.order_date && formik.errors.order_date && (
                          <FeildError>{formik.errors.order_date}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 10. Amount Paid */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Amount Paid</FormLabel>
                        <input
                          type="number"
                          name="amount_paid"
                          min="1"
                          value={formik.values.amount_paid}
                          onChange={formik.handleChange}
                          placeholder="Amount Paid"
                        />
                        {formik.touched.amount_paid &&
                          formik.errors.amount_paid && (
                            <FeildError>{formik.errors.amount_paid}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 11. Work Status */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Work Status</FormLabel>

                        <SelectSearch
                          name="work_status"
                          options={workStatusOptions}
                          onChange={(val) => { formik.setFieldValue("work_status", val); }}
                          value={formik.values.work_status}
                          placeholder="Select Work Status"
                        />

                        {formik.touched.work_status &&
                          formik.errors.work_status && (
                            <FeildError>{formik.errors.work_status}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 12. Project Done Percentage */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Project Done</FormLabel>
                        {/* <SelectSearch
                      name="project_percent_done"
                      options={percentageOptions}
                      formik={formik}
                      placeholder="Select Percentage"
                    /> */}
                        <input
                          type="number"
                          name="project_percent_done"
                          value={formik.values.project_percent_done}
                          onChange={formik.handleChange}
                          placeholder="Project Done"
                        />

                        {formik.touched.project_percent_done &&
                          formik.errors.project_percent_done && (
                            <FeildError>
                              {formik.errors.project_percent_done}
                            </FeildError>
                          )}
                      </FeildWraper>

                      <FormLineBreak />

                      <FormHeading1>Refund or CB</FormHeading1>

                      {/* 13. CB or Refund */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>CB or Refund</FormLabel>
                        <SelectSearch
                          name="cb_or_refund"
                          options={cbOrRefundOptions}
                          onChange={(val) => { formik.setFieldValue("cb_or_refund", val); }}
                          value={formik.values.cb_or_refund}
                          placeholder="Select CB/Refund"
                        />
                        {formik.touched.cb_or_refund &&
                          formik.errors.cb_or_refund && (
                            <FeildError>{formik.errors.cb_or_refund}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 14. Request Date */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Request Date</FormLabel>
                        <input
                          type="date"
                          name="request_date"
                          max={new Date().toISOString().split("T")[0]}
                          value={formik.values.request_date}
                          onChange={formik.handleChange}
                          placeholder="Request Date"
                        />
                        {formik.touched.request_date &&
                          formik.errors.request_date && (
                            <FeildError>{formik.errors.request_date}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 15. Process Date */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Process Date</FormLabel>
                        <input
                          type="date"
                          name="process_date"
                          max={new Date().toISOString().split("T")[0]}
                          value={formik.values.process_date}
                          onChange={formik.handleChange}
                          placeholder="Process Date"
                        />
                        {formik.touched.process_date &&
                          formik.errors.process_date && (
                            <FeildError>{formik.errors.process_date}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 16. Refund Amount */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Refund Amount</FormLabel>
                        <input
                          type="number"
                          name="refund_amount"
                          min="0"
                          value={formik.values.refund_amount}
                          onChange={formik.handleChange}
                          placeholder="Refund Amount"
                        />
                        {formik.touched.refund_amount &&
                          formik.errors.refund_amount && (
                            <FeildError>{formik.errors.refund_amount}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 17. Dispute Amount */}
                      {/* <FeildWraper width="25%" className={Style.responsive33}>
                    <FormLabel>Dispute Amount</FormLabel>
                    <input
                      type="number"
                      name="dispute_amount"
                      min="0"
                      value={formik.values.dispute_amount}
                      onChange={formik.handleChange}
                      placeholder="Dispute Amount"
                    />
                    {formik.touched.dispute_amount &&
                      formik.errors.dispute_amount && (
                        <FeildError>{formik.errors.dispute_amount}</FeildError>
                      )}
                  </FeildWraper> */}

                      {/* 20. Source */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Source</FormLabel>

                        <SelectSearch
                          name="source"
                          options={sourceOptions}
                          onChange={(val) => { formik.setFieldValue("source", val); }}
                          value={formik.values.source}
                          placeholder="Select Source"
                        />

                        {formik.touched.source && formik.errors.source && (
                          <FeildError>{formik.errors.source}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 21. Front Sale */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Front Sale</FormLabel>
                        <SelectSearch
                          name="front_sale"
                          options={agentOptions}
                          onChange={(val) => { formik.setFieldValue("front_sale", val); }}
                          value={formik.values.front_sale}
                          placeholder="Select Front Sale"
                        />
                        {formik.touched.front_sale && formik.errors.front_sale && (
                          <FeildError>{formik.errors.front_sale}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 22. Account Manager */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Account Manager</FormLabel>
                        <SelectSearch
                          name="account_manager"
                          options={agentOptions}
                          onChange={(val) => { formik.setFieldValue("account_manager", val); }}
                          value={formik.values.account_manager}
                          placeholder="Select Account Manager"
                        />
                        {formik.touched.account_manager &&
                          formik.errors.account_manager && (
                            <FeildError>{formik.errors.account_manager}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 23. Processor Reason Code */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Processor Reason Code</FormLabel>
                        <input
                          type="text"
                          name="processor_reason_code"
                          value={formik.values.processor_reason_code}
                          onChange={formik.handleChange}
                          placeholder="Processor Reason Code"
                        />
                        {/* <SelectSearch
                      name="processor_reason_code"
                      options={processorReasonOptions}
                      formik={formik}
                      placeholder="Select Processor Reason Code"
                    /> */}
                        {formik.touched.processor_reason_code &&
                          formik.errors.processor_reason_code && (
                            <FeildError>
                              {formik.errors.processor_reason_code}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 24. QA Status */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>QA Status</FormLabel>

                        <SelectSearch
                          name="qa_status"
                          options={qaStatusOptions}
                          onChange={(val) => { formik.setFieldValue("qa_status", val); }}
                          value={formik.values.qa_status}
                          placeholder="Select QA Status"
                        />

                        {formik.touched.qa_status && formik.errors.qa_status && (
                          <FeildError>{formik.errors.qa_status}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 25. Identified by QA */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Identified by QA</FormLabel>
                        <SelectSearch
                          name="identified_by_qa"
                          options={yesNoOptions}
                          onChange={(val) => { formik.setFieldValue("identified_by_qa", val); }}
                          value={formik.values.identified_by_qa}
                          placeholder="Select Yes/No"
                        />
                        {formik.touched.identified_by_qa &&
                          formik.errors.identified_by_qa && (
                            <FeildError>
                              {formik.errors.identified_by_qa}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 26. Business Unit */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Business Unit</FormLabel>
                        <SelectSearch
                          name="business_unit"
                          options={businessUnits}
                          onChange={(val) => { formik.setFieldValue("business_unit", val); }}
                          value={formik.values.business_unit}
                          placeholder="Select Business Unit"
                        />
                        {formik.touched.business_unit &&
                          formik.errors.business_unit && (
                            <FeildError>{formik.errors.business_unit}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 28. QA Executive */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>QA Executive</FormLabel>
                        <SelectSearch
                          name="qa_executive"
                          options={qaExecutiveOptions}
                          onChange={(val) => { formik.setFieldValue("qa_executive", val); }}
                          value={formik.values.qa_executive}
                          placeholder="Select QA Executive"
                        />
                        {formik.touched.qa_executive &&
                          formik.errors.qa_executive && (
                            <FeildError>{formik.errors.qa_executive}</FeildError>
                          )}
                      </FeildWraper>


                      {/* 33. QA Analysis */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>QA Analysis</FormLabel>
                        <input
                          type="text"
                          name="qa_analysis"
                          value={formik.values.qa_analysis}
                          onChange={formik.handleChange}
                          placeholder="QA Analysis"
                        />
                        {formik.touched.qa_analysis &&
                          formik.errors.qa_analysis && (
                            <FeildError>{formik.errors.qa_analysis}</FeildError>
                          )}
                      </FeildWraper>

                      {/* 34. Disagreement with QA */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Disagreement with QA</FormLabel>
                        <SelectSearch
                          name="disagreement_with_qa"
                          options={yesNoOptions}
                          onChange={(val) => { formik.setFieldValue("disagreement_with_qa", val); }}
                          value={formik.values.disagreement_with_qa}
                          placeholder="Select Yes/No"
                        />
                        {formik.touched.disagreement_with_qa &&
                          formik.errors.disagreement_with_qa && (
                            <FeildError>
                              {formik.errors.disagreement_with_qa}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 29. Responsible */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Responsible</FormLabel>
                        <SelectSearch
                          name="responsible"
                          options={responsibleOptions}
                          onChange={(val) => { formik.setFieldValue("responsible", val); }}
                          value={formik.values.responsible}
                          placeholder="Select Responsible"
                          menuPosition="fixed"
                        />
                        {formik.touched.responsible &&
                          formik.errors.responsible && (
                            <FeildError>{formik.errors.responsible}</FeildError>
                          )}
                      </FeildWraper>

                      {formik.values.responsible != "2" && (
                        <>
                          {/* 32. Responsible Person */}
                          <FeildWraper width="25%" className={Style.responsive33}>
                            <FormLabel>Responsible Person</FormLabel>
                            <SelectSearch
                              name="responsible_person"
                              options={agentOptions}
                              onChange={(val) => { formik.setFieldValue("responsible_person", val); }}
                              value={formik.values.responsible_person}
                              placeholder="Select Responsible Person"
                              menuPosition="fixed"
                            />
                            {formik.touched.responsible_person &&
                              formik.errors.responsible_person && (
                                <FeildError>
                                  {formik.errors.responsible_person}
                                </FeildError>
                              )}
                          </FeildWraper>

                          {/* 30. Team Lead 1 */}
                          <FeildWraper width="25%" className={Style.responsive33}>
                            <FormLabel>Team Lead 1</FormLabel>
                            <SelectSearch
                              name="team_lead_1"
                              options={agentOptions}
                              onChange={(val) => { formik.setFieldValue("team_lead_1", val); }}
                              value={formik.values.team_lead_1}
                              placeholder="Select Team Lead 1"
                              menuPosition="fixed"
                            />
                            {formik.touched.team_lead_1 &&
                              formik.errors.team_lead_1 && (
                                <FeildError>{formik.errors.team_lead_1}</FeildError>
                              )}
                          </FeildWraper>

                          {/* 31. Team Lead 2 */}
                          <FeildWraper width="25%" className={Style.responsive33}>
                            <FormLabel>Team Lead 2</FormLabel>
                            <SelectSearch
                              name="team_lead_2"
                              options={agentOptions}
                              onChange={(val) => { formik.setFieldValue("team_lead_2", val); }}
                              value={formik.values.team_lead_2}
                              placeholder="Select Team Lead 2"
                              menuPosition="fixed"
                            />
                            {formik.touched.team_lead_2 &&
                              formik.errors.team_lead_2 && (
                                <FeildError>{formik.errors.team_lead_2}</FeildError>
                              )}
                          </FeildWraper>

                          {/* 27. Reporting Authority */}
                          <FeildWraper width="25%" className={Style.responsive33}>
                            <FormLabel>Reporting Authority</FormLabel>
                            <SelectSearch
                              name="reporting_authority"
                              options={agentOptions}
                              onChange={(val) => { formik.setFieldValue("reporting_authority", val); }}
                              value={formik.values.reporting_authority}
                              placeholder="Select Reporting Authority"
                              menuPosition="fixed"
                            />
                            {formik.touched.reporting_authority &&
                              formik.errors.reporting_authority && (
                                <FeildError>
                                  {formik.errors.reporting_authority}
                                </FeildError>
                              )}
                          </FeildWraper>
                        </>
                      )}

                      {/* 35. QA Decision Changed */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>QA Decision Changed</FormLabel>
                        <SelectSearch
                          name="qa_decision_changed"
                          options={yesNoOptions}
                          onChange={(val) => { formik.setFieldValue("qa_decision_changed", val); }}
                          value={formik.values.qa_decision_changed}
                          placeholder="Select Yes/No"
                          menuPosition="fixed"
                        />
                        {formik.touched.qa_decision_changed &&
                          formik.errors.qa_decision_changed && (
                            <FeildError>
                              {formik.errors.qa_decision_changed}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 36. QA of QA */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>QA of QA</FormLabel>
                        <input
                          type="text"
                          name="qa_of_qa"
                          value={formik.values.qa_of_qa}
                          onChange={formik.handleChange}
                          placeholder="QA of QA"
                        />
                        {formik.touched.qa_of_qa && formik.errors.qa_of_qa && (
                          <FeildError>{formik.errors.qa_of_qa}</FeildError>
                        )}
                      </FeildWraper>

                      {/* 37. First Call Upsell Attempt */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>First Call Upsell Attempt</FormLabel>
                        <SelectSearch
                          name="first_call_upsell_attempt"
                          options={yesNoOptions}
                          onChange={(val) => { formik.setFieldValue("first_call_upsell_attempt", val); }}
                          value={formik.values.first_call_upsell_attempt}
                          placeholder="Select Yes/No"
                          menuPosition="fixed"
                        />
                        {formik.touched.first_call_upsell_attempt &&
                          formik.errors.first_call_upsell_attempt && (
                            <FeildError>
                              {formik.errors.first_call_upsell_attempt}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 40. CB Outcome */}
                      {formik.values.cb_or_refund == 2 || formik.values.cb_or_refund == 3 || formik.values.cb_or_refund == 4 ? (

                        <FeildWraper width="25%" className={Style.responsive33}>
                          <FormLabel>CB Outcome</FormLabel>
                          <SelectSearch
                            name="cb_outcome"
                            options={cbOutcomeOptions}
                            onChange={(val) => { formik.setFieldValue("cb_outcome", val); }}
                            value={formik.values.cb_outcome}
                            placeholder="Select CB Outcome"
                            menuPosition="fixed"
                          />
                          {formik.touched.cb_outcome && formik.errors.cb_outcome && (
                            <FeildError>{formik.errors.cb_outcome}</FeildError>
                          )}
                        </FeildWraper>

                      ) : null}

                      <FormLineBreak />
                      <FormHeading1>Retention</FormHeading1>

                      {/* 38. Retention Attempt */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Retention Attempt</FormLabel>
                        <SelectSearch
                          name="retention_attempted"
                          options={retentionAttemptOptions}
                          onChange={(val) => { formik.setFieldValue("retention_attempted", val); }}
                          value={formik.values.retention_attempted}
                          placeholder="Select Yes/No"
                          menuPosition="fixed"
                        />
                        {formik.touched.retention_attempted &&
                          formik.errors.retention_attempted && (
                            <FeildError>
                              {formik.errors.retention_attempted}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* 39. Retention Outcome */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Retention Outcome</FormLabel>
                        <SelectSearch
                          name="retention_outcome"
                          options={retentionOutcomeOptions}
                          onChange={(val) => { formik.setFieldValue("retention_outcome", val); }}
                          value={formik.values.retention_outcome}
                          placeholder="Select Retention Outcome"
                          menuPosition="fixed"
                        />
                        {formik.touched.retention_outcome &&
                          formik.errors.retention_outcome && (
                            <FeildError>{formik.errors.retention_outcome}</FeildError>
                          )}
                      </FeildWraper>






                      {/* 42. Recovery Rate */}
                      <FeildWraper width="25%" className={Style.responsive33}>
                        <FormLabel>Recovery Rate (%)</FormLabel>
                        {/* <SelectSearch
                      name="recovery_rate_percent"
                      options={percentageOptions}
                      formik={formik}
                      placeholder="Select Recovery Rate"
                    /> */}
                        <input
                          type="text"
                          name="recovery_rate_percent"
                          value={formik.values.recovery_rate_percent}
                          onChange={formik.handleChange}
                          placeholder="Recovery Rate"
                          menuPosition="fixed"
                        />

                        {formik.touched.recovery_rate_percent &&
                          formik.errors.recovery_rate_percent && (
                            <FeildError>
                              {formik.errors.recovery_rate_percent}
                            </FeildError>
                          )}
                      </FeildWraper>


                      <FeildWraper width="50%">
                        <FormLabel>Case Study</FormLabel>
                        <FileUploadProgressBar
                          name="cs_attachment_id"
                          // onChange={(val) => setUploadFiles([val]) }
                          onChange={(val) => setUploadFileId(val)}
                          acceptType="docPdf"
                        // isReturnFile={true}
                        // mode="multi"
                        />

                        {formik.touched.cs_attachment_id && formik.errors.cs_attachment_id && (
                          <FeildError>{formik.errors.cs_attachment_id}</FeildError>
                        )}



                      </FeildWraper>


                      {/* <FeildWraper width="50%">
                        {uploadFiles && (
                          <div className="mt-8 flex items-center justify-between rounded-xl border border-gray-200 bg-white p-3 shadow-sm hover:shadow-md">
                            <div className="flex flex-col">
                              <p className="text-sm font-medium truncate">{uploadFiles.name}</p>

                              {uploadFiles.size && (
                                <p className="text-xs text-gray-500">
                                  {(uploadFiles.size / 1024).toFixed(1)} KB
                                </p>
                              )}

                              {uploadFiles.url && (
                                <a
                                  href={uploadFiles.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="text-blue-600 text-xs underline hover:text-blue-800"
                                >
                                  View / Download
                                </a>
                              )}
                            </div>

                            <button
                              type="button"
                              onClick={() => setUploadFiles(null)}
                              className="text-red-500 hover:bg-red-50 rounded p-1"
                            >
                              <Delete />
                            </button>
                          </div>
                        )}
                      </FeildWraper> */}






                      {/* 43. Case Study */}
                      {/* <FeildWraper width="25%" className={Style.responsive33}>
                    <FormLabel>Case Study</FormLabel>
                    <input
                      type="text"
                      name="case_study"
                      value={formik.values.case_study}
                      onChange={formik.handleChange}
                      placeholder="Case Study"
                    />
                    {formik.touched.case_study && formik.errors.case_study && (
                      <FeildError>{formik.errors.case_study}</FeildError>
                    )}
                  </FeildWraper> */}



                    </FormArea>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${Style.dcmb__cardFoot}`}>
              {/* <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button> */}


              <button
                type="submit"
                className={Style.dcmb__submit}
                disabled={buttonLoader}
              >
                {buttonLoader ? <span className={Style.spinner}></span> : "Save"}
              </button>
            </div>
          </>


        )}
      </LeftSidePopupLayout>
    </form>
  );
};

export default RefundForm;
